/**
 * Left pads the passed string to desired length.
 *
 * @param {Number} len Length of padded string.
 * @param {String} string String to pad.
 * @param {String} paddingString String to pad the passed string with.
 * @return {String} Padded string.
 */
export default (len, originalString = '', originalPaddingString = '0') => {
	const str = String(originalString);
	const padStr = String(originalPaddingString);
	const padLength = len - str.length;
	if (padLength < 1) {
		return str;
	}
	return padStr.repeat(len - str.length) + str;
};



// WEBPACK FOOTER //
// ./src/utils/leftPad.js